var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.file.fileurl,"target":"_blank"}},[_c('i',{class:['iconfont', 'icon', _vm.icon]}),_c('span',[_vm._v(_vm._s(_vm.file.filename))])])}
var staticRenderFns = []

export { render, staticRenderFns }